import { inject, Injectable } from '@angular/core';
import { tap, throwError } from 'rxjs';
import { User } from '../auth.model';
import { AuthStore } from '../auth.store';
import { AuthService } from '../auth.service';
import { AppError } from '../../error/app-error';
import { ERROR_MAP } from '../../error/error-messages.const';

@Injectable({
  providedIn: 'root'
})
export class UserFacade {
  readonly #authService = inject(AuthService);
  readonly #authStore = inject(AuthStore);

  changeUserData(data: User['data']) {
    if (!data) {
      return throwError(
        () =>
          new AppError(
            'NO_DATA_PROVIDED',
            ERROR_MAP['NO_DATA_PROVIDED'].logMessage,
            ERROR_MAP['NO_DATA_PROVIDED'].uiMessage
          )
      );
    }

    const user = this.#authStore.user();

    if (user == null) {
      return throwError(
        () =>
          new AppError(
            'USER_NOT_LOGGED_IN',
            ERROR_MAP['USER_NOT_LOGGED_IN'].logMessage,
            ERROR_MAP['USER_NOT_LOGGED_IN'].uiMessage
          )
      );
    }

    return this.#authService
      .updateUserData(data)
      .pipe(tap((user) => this.#authStore.updateUser(user)));
  }
}
